import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import HotelIcon from '@mui/icons-material/Hotel';
import RepeatIcon from '@mui/icons-material/Repeat';
import Typography from '@mui/material/Typography';

const WorkFlowBox = () => {
    return (
        <Box>
            <span className='mainTitle'>How it Works</span>

            <Timeline position="alternate">
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ color: 'var(--background-color)', backgroundColor: 'var(--color)' }}>
                            <span className='dotIcon'>1</span>
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '20px', px: 2 }}>
                        <span className='timelineTitle'>
                            Choose Your Tech Focus
                        </span>
                        <Typography className='timelineText'>Select your preferred tech skills, from computer science to web development and programming languages.</Typography>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ color: 'var(--background-color)', backgroundColor: 'var(--color)' }}>
                            <span className='dotIcon'>2</span>
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '20px', px: 2 }}>
                        <span className='timelineTitle'>
                            Take the Practice Test
                        </span>
                        <Typography className='timelineText'>Answer a variety of MCQs tailored for tech enthusiasts. If you make a mistake, that's okay - learning from your errors is part of the process.</Typography>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ color: 'var(--background-color)', backgroundColor: 'var(--color)' }}>
                            <span className='dotIcon'>3</span>
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '20px', px: 2 }}>
                        <span className='timelineTitle'>
                            AI-Powered Feedback
                        </span>
                        <Typography className='timelineText'>After your test, access AI-generated feedback for your incorrect answers by clicking on the provided buttons. Deepen your understanding of tech concepts.</Typography>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ color: 'var(--background-color)', backgroundColor: 'var(--color)' }}>
                            <span className='dotIcon'>4</span>
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '20px', px: 2 }}>
                        <span className='timelineTitle'>
                            Track Your Progress
                        </span>
                        <Typography className='timelineText'>Keep an eye on your tech performance with detailed statistics and charts. Set tech goals and witness your improvement.</Typography>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot sx={{ color: 'var(--background-color)', backgroundColor: 'var(--color)' }}>
                            <span className='dotIcon'>5</span>
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: '20px', px: 2 }}>
                        <span className='timelineTitle'>
                            Build Tech Confidence
                        </span>
                        <Typography className='timelineText'>As you learn and practice, your confidence in tech-related exams, job interviews, and your tech career will soar.</Typography>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>

        </Box>
    )
}

export default WorkFlowBox


const Box = styled.div`
display: flex;
width: 90%;
margin: 10rem auto;
flex-direction: column;
align-items: center;


.mainTitle {
    font-size: 4rem;
    font-weight: 600;
    margin-bottom: 3rem;
    color: var(--color);
}

.dotIcon {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    font-weight: 600;
}

.timelineTitle {
    font-size: 1.85rem;
}


.timelineText {
    font-size: 1.5rem;
}

`





